import useQueryTags from 'api/tags/useQueryTags';
import TAG_TYPES from 'api/tags/TAG_TYPES';

export default function useQueryAllPipelineTags(options) {
  return useQueryTags({ type: TAG_TYPES.PIPELINE, ...options });
}
